// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1Moss","tab":"Tabs_tab__30y7W","tabActive":"Tabs_tabActive__2slZc"};